import React, { useState } from "react";
import useForgotPassword from "../hooks/useForgotPassword";

const ForgotPasswordModal = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const forgotPasswordMutation = useForgotPassword();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setMessage("Please enter your email address");
      return;
    }

    // Clear any previous messages
    setMessage("");

    const resetUrl = `${window.location.origin}/user/resetpassword`;

    forgotPasswordMutation.mutate(
      { email, resetUrl },
      {
        onSuccess: () => {
          setMessage(
            "Password reset email sent successfully! Please check your inbox."
          );
          setEmail("");
        },
        onError: (error) => {
          setMessage(
            error.message || "Failed to send reset email. Please try again."
          );
        },
      }
    );
  };

  const handleClose = () => {
    setEmail("");
    setMessage("");
    forgotPasswordMutation.reset();
  };

  return (
    <div
      className="modal fade small-text"
      id="forgotPassword"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ width: "395px" }}>
        <div
          className="modal-content pt-3 border-0"
          style={{ borderRadius: "10px" }}
        >
          <div className="modal-header border-0">
            <div className="flex-grow-1 text-center">
              <h5 className="text_primary" style={{ fontWeight: 700 }}>
                Reset your password
              </h5>
            </div>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            >
              <span
                className="text_primary"
                style={{ fontSize: 33, fontWeight: "600" }}
                aria-hidden="true"
              >
                &times;
              </span>
            </button>
          </div>
          <form>
            <div className="modal-body px-3">
              <label>Enter your email associated with your account:</label>
              <div>
                <input
                  type="email"
                  placeholder="Email address"
                  className="form-control text-dark outline-none"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={forgotPasswordMutation.isLoading}
                  required
                />
              </div>
              {message && (
                <div
                  className={`mt-2 small ${
                    forgotPasswordMutation.isSuccess
                      ? "text-success"
                      : "text-danger"
                  }`}
                >
                  {message}
                </div>
              )}
            </div>
            <div className="modal-footer d-flex justify-content-between align-items-center border-0">
              <button
                type="button"
                className="btn btn_outline_danger overlay-btn"
                data-dismiss="modal"
                onClick={handleClose}
                disabled={forgotPasswordMutation.isLoading}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="btn btn-outline-primary overlay-btn"
                onClick={handleSubmit}
                disabled={forgotPasswordMutation.isLoading}
              >
                {forgotPasswordMutation.isLoading ? "SENDING..." : "SUBMIT"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
